module.exports = __webpack_public_path__ + "static/media/community_image1.38ca4f1c.webp";